// ── CovenantCatalogPage ──
import { useState, useEffect } from "react";
import { exportCSV, localFilter } from "../../../shared/format";
import { Btn, Card, ErrorMsg, Icon, STh, SearchBar, SectionHeader, Spinner, Td, Th } from "../../../shared/ui";
import { useSortable } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const CovenantCatalogPage = () => {
    const { api, role, view, setModal, setConfirm, delRec } = useApp();
      const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [err,setErr]=useState(null); const [q,setQ]=useState("");
      const load=()=>{setLoading(true);api.get("getCovenantCatalog").then(d=>{setRows(d);setLoading(false);}).catch(e=>{setErr(e.message);setLoading(false);});};
      useEffect(()=>{load();},[]);
      const filtered=localFilter(rows,q,["category","name","description","frequencydefaults"]);
      const { sorted, sortKey, sortDir, toggle } = useSortable(filtered, 'category');
      if(loading) return <Spinner />; if(err) return <ErrorMsg msg={err} onRetry={load} />;
      return <>
        <SectionHeader actions={[
          <SearchBar key="s" value={q} onChange={setQ} placeholder="Search covenant types..." />,
          <Btn key="ex" onClick={()=>exportCSV(sorted,["category","name","description","frequencydefaults","duedateguidance","valueguidance"],"covenant_catalog.csv")}>Export CSV</Btn>,
          role.canManageUsers&&<Btn key="a" onClick={()=>setModal({type:"covenantcatalog-add",onDone:load})} variant="primary">+ Add Covenant Type</Btn>
        ].filter(Boolean)} />
        <Card style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", whiteSpace:"nowrap" }}>
            <thead><tr>
              <STh label="Category" sortKey="category" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Name" sortKey="name" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Freq Defaults" sortKey="frequencydefaults" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <STh label="Due Date Guidance" sortKey="duedateguidance" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
              <Th>Description</Th><Th></Th>
            </tr></thead>
            <tbody>{sorted.map(c=>(
              <tr key={c.id} style={{ cursor:"pointer" }} onClick={()=>setModal({type:"covenantcatalog-view",rec:c})} onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
                <Td style={{ fontWeight:500 }}>{c.category||"—"}</Td>
                <Td>{c.name||"—"}</Td>
                <Td>{c.frequencydefaults||"—"}</Td>
                <Td>{c.duedateguidance||"—"}</Td>
                <Td style={{ maxWidth:280, overflow:"hidden", textOverflow:"ellipsis" }}><span title={c.description||""}>{c.description||"—"}</span></Td>
                <Td><div style={{ display:"flex",gap:6, justifyContent:"flex-end" }} onClick={e=>e.stopPropagation()}>
                  <Btn onClick={()=>setModal({type:"covenantcatalog-view",rec:c})}><Icon type="view" /></Btn>
                  {role.canManageUsers&&<Btn onClick={()=>setModal({type:"covenantcatalog-edit",rec:c,onDone:load})}><Icon type="edit" /></Btn>}
                  {role.canManageUsers&&<Btn variant="danger" onClick={()=>setConfirm({msg:'Delete "'+(c.name||"")+'"?',onConfirm:()=>delRec("CovenantCatalog",c.id,"Deleted covenant type",load)})}><Icon type="delete" /></Btn>}
                </div></Td>
              </tr>
            ))}</tbody>
          </table>
        </Card>
      </>;
    };
